import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Attachment, Message } from '../../interface';
import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';

@Component({
  selector: 'skypro-message',
  templateUrl: 'message.html',
  styleUrls: ['message.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MessageComponent {
  @Input() message: Message;
  @Input() bigAttachmentPreview = false;

  trackByAttachment(_index: number, attachment: Attachment): string {
    return attachment.url;
  }

  formatTime({ createdAt, isEdited }: Message): string {
    if (!createdAt) {
      return '';
    }

    const localDate = typeof createdAt === 'string' ? parseISO(createdAt) : createdAt;
    const formatedDate = format(localDate, 'dd.MM.yy HH:mm');

    if (isEdited) {
      const editText = 'ред.';
      return `(${editText}) ${formatedDate}`;
    }

    return formatedDate;
  }
}
